import React, { useState } from 'react';
import classNames from 'classnames';
import RoundButton from '../../../../components/RoundButton';
import './styles.css';

const NavButton = ({
  onClick,
  active,
  hasSelected,
  children,
  className,
  ...props
}) => {
  const [hovered, setHovered] = useState();
  return (
    <RoundButton
      type="button"
      className={classNames('Listview__Filters__NavButton__root', {
        'Listview__Filters__NavButton__root--active': active,
        'Listview__Filters__NavButton__root--hovered': hovered,
        [className]: className,
      })}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      size="small"
      theme="outlineLightBlue"
      onClick={onClick}
      {...props}
    >
      {children}{' '}
      {hasSelected > 0 ? (
        <span className="Listview__Filters__NavButton__dot">{hasSelected}</span>
      ) : (
        ''
      )}
    </RoundButton>
  );
};

export default NavButton;
